import {
  updateUserMutationGQL,
  createUserMutationGQL,
} from './graphql';

export const types = {
  OPEN_ENTRY_MODAL: 'admin/userList/OPEN_ENTRY_MODAL',
  CLOSE_ENTRY_MODAL: 'admin/userList/CLOSE_ENTRY_MODAL',
  SET_SHOW_TERMINATED_USERS: 'admin/userList/SET_SHOW_TERMINATED_USERS',
};


export const openEntryModal = (user) => {
  return {
    type: types.OPEN_ENTRY_MODAL,
    user,
  };
};

export const closeUserModal = () => {
  return {
    type: types.CLOSE_ENTRY_MODAL,
  };
};

export const setShowTerminatedUsers = (showTerminatedUsers) => {
  return {
    type: types.SET_SHOW_TERMINATED_USERS,
    showTerminatedUsers,
  };
};

export const dispatchCreateUpdateUser = (user) => {
  return async (dispatch, getState, { client }) => {
    if (user.id) {
      await updateUserMutationGQL(client, user);
    } else {
      await createUserMutationGQL(client, user);
    }
    dispatch(closeUserModal());
  };
};
